/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    getUserRole,
    SaveUserRole,
    getRoleDetailsByID,
    EditUserRole,
    GetAllGroupsForDropDown,
    GetFactoriesByGroupID
};

async function getUserRole(groupID, operationEntityID, level) {
    const response = await CommonGet('/api/Role/GetRolesByRoleLevel', 'roleLevelID=' + parseInt(level) + '&groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    if (response.data != null) {
        return response.data;
    }
    return null;
}


async function getRoleDetailsByID(id) {
    const response = await CommonGet('/api/Role/GetRoleDetailsByID', 'roleID=' + parseInt(id));
    if (response.data != null) {
        return response.data;
    }
    return null;
}


async function SaveUserRole(values, user) {

    var formdata = {
        groupID: parseInt(values.groupID),
        factoryID: parseInt(values.operationEntityID),
        roleLevelID: parseInt(values.roleLevelID),
        roleName: values.roleName,
        isActive: values.isActive,
        createdBy: user
    }

    const response = await CommonPost('/api/Role/SaveRole', null, formdata);
    return response;

}

async function EditUserRole(values, user, roleID) {

    var formdata = {
        roleID: parseInt(roleID),
        groupID: parseInt(values.groupID),
        factoryID: parseInt(values.operationEntityID),
        roleLevelID: parseInt(values.roleLevelID),
        roleName: values.roleName,
        isActive: values.isActive,
        modifiedBy: user
    }

    const response = await CommonPost('/api/Role/UpdateRole', null, formdata);
    return response;

}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}


